import React, { useState } from 'react'
import stepperthreeStyle from './RegistermobilStepThree.module.css'
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export default function RegistermobilStepThree() {

  // Password Eyes
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };

  // Confirm Password Eyes
  const [isCPasswordVisible, setCPasswordVisible] = useState(false);

  const toggleCPasswordVisibility = () => {
    setCPasswordVisible(!isCPasswordVisible);
  };

  return (
    <>
      <div className={stepperthreeStyle.stepperThree}>
        <div className='row'>
          <div className='col-7'>
            <h3> Choose a Password </h3>
          </div>
          <div className='col-5'>
          </div>
        </div>
        <h5> Password Information </h5>
        <div className='row'>
          <div className='col-12'>
            <div className="mb-3">
              <div className={stepperthreeStyle.threepasswordWrapper}>
                <input type={isPasswordVisible ? "text" : "password"} id="password-field" className={`${stepperthreeStyle.threeInput} form-control`} placeholder='Choose your password' name="password" required />
                <div className={stepperthreeStyle.threetoggleButton} onClick={togglePasswordVisibility}>
                  {isPasswordVisible ? <FaEyeSlash className={stepperthreeStyle.threeIconeye} /> : <FaEye className={stepperthreeStyle.threeIconeye} />}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <div className="mb-3">
              <div className={stepperthreeStyle.threepasswordWrapper}>
                <input type={isCPasswordVisible ? "text" : "password"} id="password-field1" className={`${stepperthreeStyle.threeInput} form-control`} placeholder='Confirm your password' name="confirmPassword" required />
                <div className={stepperthreeStyle.threetoggleButton} onClick={toggleCPasswordVisibility}>
                  {isCPasswordVisible ? <FaEyeSlash className={stepperthreeStyle.threeIconeye} /> : <FaEye className={stepperthreeStyle.threeIconeye} />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
